// src/components/Services.js (VERSÃO FINAL COM i18n E useEffect CORRIGIDO)
import React, { useEffect, useRef, useState } from 'react';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import '../styles/services.css';

function Services() {
  const { t } = useTranslation();
  const servicesRef = useRef(null);

  // Estados dos Modais (mantidos)
  const [isCalculoModalOpen, setIsCalculoModalOpen] = useState(false);
  const [isGrafotecnicaModalOpen, setIsGrafotecnicaModalOpen] = useState(false);
  const [isDocumentoscopiaModalOpen, setIsDocumentoscopiaModalOpen] =
    useState(false);
  const [isAmbientalModalOpen, setIsAmbientalModalOpen] = useState(false);
  const [isInformaticaModalOpen, setIsInformaticaModalOpen] = useState(false);
  const [isAdministradorModalOpen, setIsAdministradorModalOpen] =
    useState(false);
  const [isRecuperacaoModalOpen, setIsRecuperacaoModalOpen] = useState(false);
  const [isAssistenteModalOpen, setIsAssistenteModalOpen] = useState(false);

  const [isAutoauditoriaModalOpen, setIsAutoauditoriaModalOpen] =
    useState(false);
  const [isValuationModalOpen, setIsValuationModalOpen] = useState(false);
  const [isOrganizacaoModalOpen, setIsOrganizacaoModalOpen] = useState(false);
  const [isEstoquesModalOpen, setIsEstoquesModalOpen] = useState(false);
  const [isSistemasModalOpen, setIsSistemasModalOpen] = useState(false);
  const [
    isTreinamentoOperacionalModalOpen,
    setIsTreinamentoOperacionalModalOpen,
  ] = useState(false);
  const [isTreinamentoCustosModalOpen, setIsTreinamentoCustosModalOpen] =
    useState(false);
  const [isExcelModalOpen, setIsExcelModalOpen] = useState(false);

  // ============================================
  // BLOCO useEffect CORRIGIDO
  // ============================================
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    };

    // Função de Callback para o Intersection Observer
    const handleIntersection = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          // Se quiser que a animação ocorra apenas uma vez, descomente:
          // observer.unobserve(entry.target);
        }
      });
    };

    // CORREÇÃO: Passando a função de callback (handleIntersection) corretamente
    const observer = new IntersectionObserver(
      handleIntersection,
      observerOptions,
    );

    const serviceCards =
      servicesRef.current?.querySelectorAll('.service-category');
    serviceCards?.forEach(card => {
      // Configuração inicial da animação (transição)
      card.style.opacity = '0';
      card.style.transform = 'translateY(30px)';
      card.style.transition = 'all 0.6s ease';
      observer.observe(card);
    });

    // Função de limpeza (cleanup)
    return () => observer.disconnect();
  }, []);

  // Funções de abertura/fechamento dos Modais (mantidas)
  const openCalculoModal = () => setIsCalculoModalOpen(true);
  const closeCalculoModal = () => setIsCalculoModalOpen(false);
  const openGrafotecnicaModal = () => setIsGrafotecnicaModalOpen(true);
  const closeGrafotecnicaModal = () => setIsGrafotecnicaModalOpen(false);
  const openDocumentoscopiaModal = () => setIsDocumentoscopiaModalOpen(true);
  const closeDocumentoscopiaModal = () => setIsDocumentoscopiaModalOpen(false);
  const openAmbientalModal = () => setIsAmbientalModalOpen(true);
  const closeAmbientalModal = () => setIsAmbientalModalOpen(false);
  const openInformaticaModal = () => setIsInformaticaModalOpen(true);
  const closeInformaticaModal = () => setIsInformaticaModalOpen(false);
  const openAdministradorModal = () => setIsAdministradorModalOpen(true);
  const closeAdministradorModal = () => setIsAdministradorModalOpen(false);
  const openRecuperacaoModal = () => setIsRecuperacaoModalOpen(true);
  const closeRecuperacaoModal = () => setIsRecuperacaoModalOpen(false);
  const openAssistenteModal = () => setIsAssistenteModalOpen(true);
  const closeAssistenteModal = () => setIsAssistenteModalOpen(false);
  const openAutoauditoriaModal = () => setIsAutoauditoriaModalOpen(true);
  const closeAutoauditoriaModal = () => setIsAutoauditoriaModalOpen(false);
  const openValuationModal = () => setIsValuationModalOpen(true);
  const closeValuationModal = () => setIsValuationModalOpen(false);
  const openOrganizacaoModal = () => setIsOrganizacaoModalOpen(true);
  const closeOrganizacaoModal = () => setIsOrganizacaoModalOpen(false);
  const openEstoquesModal = () => setIsEstoquesModalOpen(true);
  const closeEstoquesModal = () => setIsEstoquesModalOpen(false);
  const openSistemasModal = () => setIsSistemasModalOpen(true);
  const closeSistemasModal = () => setIsSistemasModalOpen(false);
  const openTreinamentoOperacionalModal = () =>
    setIsTreinamentoOperacionalModalOpen(true);
  const closeTreinamentoOperacionalModal = () =>
    setIsTreinamentoOperacionalModalOpen(false);
  const openTreinamentoCustosModal = () =>
    setIsTreinamentoCustosModalOpen(true);
  const closeTreinamentoCustosModal = () =>
    setIsTreinamentoCustosModalOpen(false);
  const openExcelModal = () => setIsExcelModalOpen(true);
  const closeExcelModal = () => setIsExcelModalOpen(false);

  return (
    <section id='services' className='services' ref={servicesRef}>
      <div className='services-container'>
        <div className='section-header'>
          <h2 className='section-title'>{t('services_main_title')}</h2>
          <p className='section-subtitle'>{t('services_main_subtitle')}</p>
        </div>

        <div className='services-grid'>
          {/* COLUNA 1: PERÍCIAS */}
          <div className='service-category'>
            <h3>
              <i className='fas fa-gavel'></i> {t('services_col1_title')}
            </h3>
            <p className='service-description'>
              {t('services_col1_main_desc_long')}
            </p>
            <ul className='service-list'>
              <li className='clickable-item' onClick={openCalculoModal}>
                <span>{t('services_col1_item_judicialCalculations_long')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openInformaticaModal}>
                <span>{t('services_col1_item_it')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openAmbientalModal}>
                <span>{t('services_col1_item_environmental')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openGrafotecnicaModal}>
                <span>{t('services_col1_item_graphoscopics')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openDocumentoscopiaModal}>
                <span>{t('services_col1_item_documentoscopy')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openAdministradorModal}>
                <span>{t('services_col1_item_administrator')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openRecuperacaoModal}>
                <span>{t('services_col1_item_recovery')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openAssistenteModal}>
                <span>{t('services_col1_item_assistant')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
            </ul>
          </div>

          {/* COLUNA 2: CONSULTORIAS E AUDITORIAS */}
          <div className='service-category'>
            <h3>
              <i className='fas fa-chart-line'></i> {t('services_col2_title')}
            </h3>
            <p className='service-description'>
              {t('services_col2_main_desc_long')}
            </p>
            <ul className='service-list'>
              <li className='clickable-item' onClick={openAutoauditoriaModal}>
                <span>{t('services_col2_item_autoAuditing')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openValuationModal}>
                <span>{t('services_col2_item_valuationAuditing')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openOrganizacaoModal}>
                <span>{t('services_col2_item_organizationProcedures')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openEstoquesModal}>
                <span>
                  {t('services_col2_item_inventoryAccountingAuditing')}
                </span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openSistemasModal}>
                <span>{t('services_col2_item_itDevelopment')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li
                className='clickable-item'
                onClick={openTreinamentoOperacionalModal}
              >
                <span>{t('services_col2_item_operationalTraining')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li
                className='clickable-item'
                onClick={openTreinamentoCustosModal}
              >
                <span>{t('services_col2_item_costDevelopment')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
              <li className='clickable-item' onClick={openExcelModal}>
                <span>{t('services_col2_item_excelCourse')}</span>
                <i className='fas fa-plus expand-icon'></i>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* ============================================ */}
      {/* 🛑 MODAIS DE PERÍCIAS 🛑 */}
      {/* ============================================ */}

      <Modal isOpen={isCalculoModalOpen} onClose={closeCalculoModal}>
        <h3>{t('modal_calculo_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_calculo_p1')}</p>
            <p>{t('modal_calculo_p2')}</p>
          </div>
          <img src='img/Pericia/Cálculos.png' alt={t('modal_calculo_alt')} />
        </div>
      </Modal>

      <Modal isOpen={isGrafotecnicaModalOpen} onClose={closeGrafotecnicaModal}>
        <h3>{t('modal_grafotecnica_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_grafotecnica_p1')}</p>
            <p>{t('modal_grafotecnica_p2')}</p>
          </div>
          <img
            src='img/Pericia/Grafotécnica.png'
            alt={t('modal_grafotecnica_alt')}
          />
        </div>
      </Modal>

      <Modal
        isOpen={isDocumentoscopiaModalOpen}
        onClose={closeDocumentoscopiaModal}
      >
        <h3>{t('modal_documentoscopia_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_documentoscopia_p1')}</p>
            <p>{t('modal_documentoscopia_p2')}</p>
          </div>
          <img
            src='img/Pericia/Documentoscópica.png'
            alt={t('modal_documentoscopia_alt')}
          />
        </div>
      </Modal>

      <Modal isOpen={isAmbientalModalOpen} onClose={closeAmbientalModal}>
        <h3>{t('modal_ambiental_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_ambiental_p1')}</p>
            <p>{t('modal_ambiental_p2')}</p>
          </div>
          <img src='img/Pericia/Ambiental.png' alt={t('modal_ambiental_alt')} />
        </div>
      </Modal>

      <Modal isOpen={isInformaticaModalOpen} onClose={closeInformaticaModal}>
        <h3>{t('modal_informatica_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_informatica_p1')}</p>
            <p>{t('modal_informatica_p2')}</p>
          </div>
          <img
            src='img/Pericia/Informatica.png'
            alt={t('modal_informatica_alt')}
          />
        </div>
      </Modal>

      <Modal
        isOpen={isAdministradorModalOpen}
        onClose={closeAdministradorModal}
      >
        <h3>{t('modal_administrador_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_administrador_p1')}</p>
            <p>{t('modal_administrador_p2')}</p>
          </div>
          <img
            src='img/Pericia/Administrador.png'
            alt={t('modal_administrador_alt')}
          />
        </div>
      </Modal>

      <Modal isOpen={isRecuperacaoModalOpen} onClose={closeRecuperacaoModal}>
        <h3>{t('modal_recuperacao_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_recuperacao_p1')}</p>
            <p>{t('modal_recuperacao_p2')}</p>
          </div>
          <img
            src='img/Pericia/Recuperacao.png'
            alt={t('modal_recuperacao _alt')}
          />
        </div>
      </Modal>

      <Modal isOpen={isAssistenteModalOpen} onClose={closeAssistenteModal}>
        <h3>{t('modal_assistente_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_assistente_p1')}</p>
            <p>{t('modal_assistente_p2')}</p>
          </div>
          <img
            src='img/Pericia/Assistente.png'
            alt={t('modal_assistente_alt')}
          />
        </div>
      </Modal>

      {/* ============================================ */}
      {/* 🛑 MODAIS DE CONSULTORIA E AUDITORIA 🛑 */}
      {/* ============================================ */}

      <Modal
        isOpen={isAutoauditoriaModalOpen}
        onClose={closeAutoauditoriaModal}
      >
        <h3>{t('modal_autoauditoria_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_autoauditoria_p1')}</p>
            <p>{t('modal_autoauditoria_p2')}</p>
          </div>
          <img
            src='img/Auditoria/Autoauditoria.png'
            alt={t('modal_autoauditoria_alt')}
          />
        </div>
      </Modal>

      <Modal isOpen={isValuationModalOpen} onClose={closeValuationModal}>
        <h3>{t('modal_valuation_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_valuation_p1')}</p>
            <p>{t('modal_valuation_p2')}</p>
          </div>
          <img
            src='img/Auditoria/Valuation.png'
            alt={t('modal_valuation_alt')}
          />
        </div>
      </Modal>

      <Modal isOpen={isOrganizacaoModalOpen} onClose={closeOrganizacaoModal}>
        <h3>{t('modal_organizacao_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_organizacao_p1')}</p>
            <p>{t('modal_organizacao_p2')}</p>
          </div>
          <img
            src='img/Auditoria/Organizacao.png'
            alt={t('modal_organizacao_alt')}
          />
        </div>
      </Modal>

      <Modal isOpen={isEstoquesModalOpen} onClose={closeEstoquesModal}>
        <h3>{t('modal_estoques_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_estoques_p1')}</p>
            <p>{t('modal_estoques_p2')}</p>
          </div>
          <img src='img/Auditoria/Estoques.png' alt={t('modal_estoques_alt')} />
        </div>
      </Modal>

      <Modal isOpen={isSistemasModalOpen} onClose={closeSistemasModal}>
        <h3>{t('modal_sistemas_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_sistemas_p1')}</p>
            <p>{t('modal_sistemas_p2')}</p>
          </div>
          <img src='img/Auditoria/Sistemas.png' alt={t('modal_sistemas_alt')} />
        </div>
      </Modal>

      <Modal
        isOpen={isTreinamentoOperacionalModalOpen}
        onClose={closeTreinamentoOperacionalModal}
      >
        <h3>{t('modal_treinamento_operacional_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_treinamento_operacional_p1')}</p>
            <p>{t('modal_treinamento_operacional_p2')}</p>
          </div>
          <img
            src='img/Auditoria/TreinamentoOperacional.png'
            alt={t('modal_treinamento_operacional_alt')}
          />
        </div>
      </Modal>

      <Modal
        isOpen={isTreinamentoCustosModalOpen}
        onClose={closeTreinamentoCustosModal}
      >
        <h3>{t('modal_treinamento_custos_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_treinamento_custos_p1')}</p>
            <p>{t('modal_treinamento_custos_p2')}</p>
          </div>
          <img
            src='img/Auditoria/TreinamentoCustos.png'
            alt={t('modal_treinamento_custos_alt')}
          />
        </div>
      </Modal>

      <Modal isOpen={isExcelModalOpen} onClose={closeExcelModal}>
        <h3>{t('modal_excel_title')}</h3>
        <div className='modal-body'>
          <div className='text-container'>
            <p>{t('modal_excel_p1')}</p>
            <p>{t('modal_excel_p2')}</p>
          </div>
          <img src='img/Auditoria/Excel.png' alt={t('modal_excel_alt')} />
        </div>
      </Modal>
    </section>
  );
}

export default Services;
